<template>
  <section>
    <pb-skeleton :loading="loading" animated :count="2">
      <template slot="template">
        <div class="wrap">
          <pb-skeleton-item variant="div" style="width: 300px; height: 30px" />
          <div class="box">
            <Fragment v-for="i in 6" :key="i">
              <div style="width: 50%">
                <pb-skeleton-item variant="div" style="width: 95%; height: 60px; margin-top: 5px" />
              </div>
            </Fragment>
          </div>
        </div>
      </template>
      <template>
        <div v-for="(parent, key) in sides" :key="parent?.name" class="wrap">
          <div class="title">
            <i :class="parent?.meta?.icon"></i>
            <span class="text">{{ parent?.meta.title || '' }}</span>
          </div>
          <div class="box">
            <Fragment v-for="(child, idx) in parent.children" :key="child?.meta?.nodeId">
              <div class="card" :class="{ 'card-highlight': child?.meta?.isAuth }" @click="() => (child?.meta.isAuth ? toModule(child) : '')">
                <div class="card-header">
                  <div class="name">
                    <span>{{ child?.meta?.title || '' }}</span>
                    <i class="GQ-chevron_inline_right" />
                    <span class="no-permission">{{ $t('Gattaran_Homepage__BYnh' /*无权限*/) }}</span>
                  </div>
                  <pb-button v-if="child?.meta?.isApply" size="mini" @click.stop="toAppyOrSee(child?.meta)">{{ $t('Gattaran_Homepage__SgjR' /** 权限列表 */) }}</pb-button>
                </div>
                <div class="card-content">{{ child?.meta?.remark }}</div>
                <!-- 只有从首页第一次进入且是第一个三级模块且可查看权限才有提示 -->
                <Instruction v-if="idx === 0 && key === 0 && child?.meta?.isApply" />
              </div>
            </Fragment>
          </div>
        </div>
      </template>
    </pb-skeleton>
  </section>
</template>

<script>
import Instruction from './components/instruction.vue';
import { setRecentVisit } from '@/pages/overview/service';
import { eventBus } from '@/micro-app';
import { gtrCollectTrackCommonData, CLICK_TYPE } from '@/utils/gattaran-track-event';
import _ from 'lodash';
export default {
  components: {
    Instruction,
  },
  props: {
    sides: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: this.sides.length === 0,
      visible: false,
      showApplyDrawer: false,
      nodeId: 0,
      moduleName: '',
    };
  },
  watch: {
    sides: {
      deep: true,
      handler(n) {
        this.loading = false;
      },
    },
  },
  methods: {
    // 去申请角色或查看角色
    toAppyOrSee: _.throttle(function (val) {
      eventBus.$emit('GTR_LISTEN_EVENT_APPLY_ROLE_DEAWER', {
        nodeId: _.get(val, 'nodeId', 0),
        moduleName: _.get(val, 'title', ''),
      });
    }, 1500),
    // 如果拥有权限去所属模块
    toModule(val) {
      // 从概览页跳转到四级模块时push模块信息
      gtrCollectTrackCommonData({
        module: {
          name: val?.meta?.title,
          nodeId: val?.meta?.nodeId,
        },
        entry_type: CLICK_TYPE.SUMMARY,
      });
      const { path = '', meta = {} } = val;
      setRecentVisit({
        nodeKey: meta?.key,
        activeMicroAppName: meta?.appName,
      }).then((res) => {
        this.$router.push(path);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  margin: 32px 24px 0;
  .title {
    display: flex;
    align-items: center;
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    color: #282b33;
    line-height: 28px;
    .text {
      margin-left: 4px;
    }
  }
  .box {
    margin-top: 16px;
    padding: 8px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .card {
    width: 50%;
    border-radius: 8px;
    padding: 16px 24px;
    box-sizing: border-box;
    position: relative;
    .card-header {
      height: 28px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .name {
        font-family: PingFangSC-Medium;
        font-size: 0;
        color: #282b33;
        line-height: 24px;
        font-weight: 500;
        span {
          font-size: 14px;
          vertical-align: middle;
          padding-right: 8px;
        }
        i {
          font-size: 14px;
          vertical-align: middle;
          display: none;
        }
        .no-permission {
          font-family: DiDiSans-Pro-Medium-Italic;
          font-size: 12px;
          color: #c2c4cc;
          line-height: 22px;
          font-weight: normal;
          display: none;
        }
      }
    }
    .card-content {
      max-width: 354px;
      margin-top: -4px;
      word-break: break-word;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #8d9099;
      text-align: left;
      line-height: 20px;
      font-weight: 400;
    }
    &:hover {
      background: #f8f8fa;
      transition: all 0.35s ease-in-out;
      i {
        display: none;
      }
      .name .no-permission {
        display: inline-block;
      }
    }
  }
  .card-highlight {
    &:hover {
      cursor: pointer;
      .name {
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #f76a31;
        line-height: 24px;
        font-weight: 500;
        cursor: pointer;
        background: #f8f8fa;
        transition: all 0.35s ease-in-out;
        transform: translateX(4px);
        i {
          display: inline-block;
        }
        .no-permission {
          display: none;
        }
      }
    }
  }
}
.bgColor {
  background: #f8f8fa;
  cursor: pointer;
}
.tooltip-button {
  margin-left: 40px;
}
</style>
